import React, { useEffect, useState, useMemo } from 'react';

// Comps
import AccountSectionLayout from '@project-stories/ecommerce/Account/AccountSectionLayout';
import Preloader from '@arctheme-components/blocks/Preloader/Preloader';
import {Paragraph} from '@arctheme-components/elements/Paragraph/Paragraph';
import {Link} from '@arctheme-components/elements/Link/Link';
import {ProductTile as ExtendedProductTile} from '@src/stories/ecommerce/Product/ProductTile';
import ReactPaginate from 'react-paginate';

// Utils
import shopifyHelpers from 'frontend/js/shopify';

// Hooks
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import {Button} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Button/Button";

const AccountReturns = ({ promoLabelConfig, paginateBy = 4, locales }) => {
    const [localLists, setLocalLists] = useState([]);

    useEffect(() => {
        // If needed, initialize or load localLists here
        const savedLists = JSON.parse(localStorage.getItem('localLists')) || [];
        setLocalLists(savedLists);
    }, []);

    // States
    const [products, setProducts] = useState(null);
    const [currentProducts, setCurrentProducts] = useState(null);
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);

    // Hooks
    const isMobile = useMobileBreakpoint('767px');

    // Pagination
    const pageCount = useMemo(() => Math.ceil(products?.length / paginateBy), [products]);
    const handlePageChange = (newPage) => {
        setCurrentProducts((prev) => products.slice(paginateBy * newPage, paginateBy * newPage + paginateBy));
        setCurrentPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Re-fetch products when there are updates in wishlist
    useEffect(() => {
        const fetchProducts = async () => {
            setProducts(null);
            setCurrentProducts(null);
            setCurrentPage(0);
            setIsLoadingProducts(true);

            const wishlist = localLists?.[0];

            if (!wishlist) {
                setIsLoadingProducts(false);
                return;
            }

            const graphQlProducts = await shopifyHelpers.getShopifyProductList(
                wishlist.products.map((product) => ({
                    id: product
                }))
            );

            setProducts(graphQlProducts);
            setCurrentProducts(graphQlProducts.slice(0, paginateBy));
            setIsLoadingProducts(false);
        };

        fetchProducts();
    }, [localLists]);

    const renderProducts = (products) => {
        return products.map((product) => (
            <ExtendedProductTile
                key={product.id}
                product={product}
                type='horizontal-tablet'
                enableWishlist={true}
                promoLabelConfig={promoLabelConfig}
            />
        ));
    };

    return (
        <AccountSectionLayout
            classes={`lg:pl-[98px] md:pt-8 hide-scrollbar`}
        >
            <div className={`flex flex-col space-y-[16px] lg:w-[360px]`}>
                <p>
                    In order to organise a return please click the button below to contact our customer service team.
                </p>
                <Link
                    classes={`mt-4 button button-primary`}
                    link={`https://lee-mathews.loopreturns.com/#/`}>{`Book A Return`}
                </Link>
            </div>
        </AccountSectionLayout>
    );
};

export default AccountReturns;
